var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"sidebar-bg"}),_vm._v(" "),_c('section',{staticClass:"section"},[_c('div',{staticClass:"container is-fullhd template-horizontal"},[_c('div',{staticClass:"is-hidden-mobile",staticStyle:{"background":"rgb(249, 247, 247)","padding":"10px","border":"1px solid rgb(228, 222, 222)"}},[_c('TheSidebar',{attrs:{"data":_vm.menu}})],1),_vm._v(" "),_c('router-view')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-767cf668","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = 541
// module chunks = 79